import { supabase } from '../../shared/supabase/supabaseClient';

/**
 * Pide a la Edge que relea el preapproval en Mercado Pago y aplique el plan.
 * El webhook sigue siendo el camino principal. Esto cubre la vuelta del checkout
 * y el poll si la notificación no llegó.
 */
export async function verifyMpSubscription(
  orgId: string | null,
  preapprovalId?: string,
): Promise<void> {
  try {
    await supabase.functions.invoke('mercadopago-subscription-verify', {
      body: {
        organization_id: orgId ?? undefined,
        preapproval_id: preapprovalId,
      },
    });
  } catch {
    /* best effort: el poll o el webhook vuelven a intentar */
  }
}
